__turbopack_context__.v({
  "action": "NotificationSettings-module-scss-module__ji7_wG__action",
  "address": "NotificationSettings-module-scss-module__ji7_wG__address",
  "addressBox": "NotificationSettings-module-scss-module__ji7_wG__addressBox",
  "addressLabel": "NotificationSettings-module-scss-module__ji7_wG__addressLabel",
  "addressText": "NotificationSettings-module-scss-module__ji7_wG__addressText",
  "badge": "NotificationSettings-module-scss-module__ji7_wG__badge",
  "browser": "NotificationSettings-module-scss-module__ji7_wG__browser",
  "browserLine": "NotificationSettings-module-scss-module__ji7_wG__browserLine",
  "browserStatus": "NotificationSettings-module-scss-module__ji7_wG__browserStatus",
  "explain": "NotificationSettings-module-scss-module__ji7_wG__explain",
  "group": "NotificationSettings-module-scss-module__ji7_wG__group",
  "groupHead": "NotificationSettings-module-scss-module__ji7_wG__groupHead",
  "groupText": "NotificationSettings-module-scss-module__ji7_wG__groupText",
  "groupTitle": "NotificationSettings-module-scss-module__ji7_wG__groupTitle",
  "hint": "NotificationSettings-module-scss-module__ji7_wG__hint",
  "label": "NotificationSettings-module-scss-module__ji7_wG__label",
  "list": "NotificationSettings-module-scss-module__ji7_wG__list",
  "listRow": "NotificationSettings-module-scss-module__ji7_wG__listRow",
  "listTerm": "NotificationSettings-module-scss-module__ji7_wG__listTerm",
  "lockIcon": "NotificationSettings-module-scss-module__ji7_wG__lockIcon",
  "lockedSwitch": "NotificationSettings-module-scss-module__ji7_wG__lockedSwitch",
  "outcome": "NotificationSettings-module-scss-module__ji7_wG__outcome",
  "outcomeError": "NotificationSettings-module-scss-module__ji7_wG__outcomeError",
  "problem": "NotificationSettings-module-scss-module__ji7_wG__problem",
  "required": "NotificationSettings-module-scss-module__ji7_wG__required",
  "root": "NotificationSettings-module-scss-module__ji7_wG__root",
  "switch": "NotificationSettings-module-scss-module__ji7_wG__switch",
  "switchKnob": "NotificationSettings-module-scss-module__ji7_wG__switchKnob",
  "switchOn": "NotificationSettings-module-scss-module__ji7_wG__switchOn",
  "switchRow": "NotificationSettings-module-scss-module__ji7_wG__switchRow",
  "verified": "NotificationSettings-module-scss-module__ji7_wG__verified",
});
